import { Affix, Button, Card, Spin } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { isArrayAndHasValue } from "utils/functions";
import { getData, postData } from "../../../apiServices/common";
import { isMobileView } from "../../Common/AppHelper";
import Header from "../../Common/Header";
import AddUnitsPriceForm from "./AddUnitsPriceForm";

export default function UpdateUnitsPrice(props) {
  // Props
  const { width } = props;
  const navigate = useNavigate();

  // States
  const [permitInfo, setPermitInfo] = useState();
  const [poDetailsData, setPoDetailsData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const location = useLocation();

  // Access the state values
  const type = location.state?.type;

  // Others
  const { itemId } = useParams();
  const propertyFormRef = useRef(null);

  const addProduct = () => {
    if (isSubmitting) return;
    propertyFormRef.current.submit();
  };

  const getPOInfo = useCallback(
    async (poMapIds = null) => {
      setIsLoading(true);
      const query = `/api/unit_prices/${itemId}/edit`;
      const payload = {};
      if (poMapIds && poMapIds.length > 0) {
        payload.po_map_ids = poMapIds;
      }

      if (type) {
        payload.type = type;
      }
      const response = await postData(query, payload);

      if (response && response?.code === 200) {
        const masterData = response.data;
        setPermitInfo(masterData);
        const po_data = masterData ? masterData.unit_price_details : null;

        const po_details =
          isArrayAndHasValue(po_data) &&
          po_data.map((item) => {
            const sizes = {};

            item?.sizes.forEach((size) => {
              sizes[size?.name + "_" + size?.id] = size?.sales_order_quantity;
            });
            return {
              ...item,
              style_id: item.style.id,
              color_id: item.color.id,
              ...sizes,
            };
          });

        setPoDetailsData(po_details || []);
      }
      setIsLoading(false);
    },
    [itemId, type],
  );

  useEffect(() => {
    // Only run on first render
    // DO NOT add any depenedency here
    getPOInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title={"Update SC PO Breakdown"}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => navigate(-1)} disabled={isSubmitting}>
                Discard
              </Button>,
              type !== "preview" && (
                <Button
                  size="small"
                  key={2}
                  type="primary"
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  onClick={() => addProduct()}
                >
                  Update
                </Button>
              ),
            ]}
          />
        </Card>
      </Affix>

      <Spin spinning={isLoading} tip="Loading...">
        <AddUnitsPriceForm
          ref={propertyFormRef}
          permitInfo={permitInfo}
          poDetailsData={poDetailsData}
          setPoDetailsData={setPoDetailsData}
          mode="update"
          getPOInfo={getPOInfo}
          isPreview={type === "preview"}
          isLoading={isLoading}
          isSubmitting={isSubmitting}
          setIsSubmitting={setIsSubmitting}
        />
      </Spin>
    </>
  );
}
